import React from "react";
import { BackHandler } from "react-native";
import NavigateActionTypes from "../../navigation/NavigateActionTypes";
import { NavigationService } from "../../navigation";

class BackScreenHandler {
    constructor(screen) {
        this.screen = screen;
        this.handleBackPress = this.handleBackPress.bind(this);
    }

    install() {
        BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    uninstall() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress() {
        NavigationService.navigateByAction(this.screen, NavigateActionTypes.BACK);
        return true;
    }
}

export default BackScreenHandler;
